import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppStateService } from '../../../core/services/app-state.service';
import { DecodedToken, JwtService } from '../../../core/services/jwt.service';
import { UserRole } from '../../../core/enums/user-role.enum';
import { Router } from '@angular/router';
import { Paths } from '../../../core/constants/path.constants';
import { Subject, takeUntil } from 'rxjs';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { LocalStorageKeys } from '../../../core/constants/local-storage.constants';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'vota-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit, OnDestroy {
  currentUserInfo: DecodedToken | null = null;
  userRole: UserRole | null = null;
  UserRoles = UserRole;
  private destroy$ = new Subject<void>();

  constructor(
    private jwtService: JwtService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private toastr: ToastrService,
    public appStateService: AppStateService
  ) {}

  ngOnInit(): void {
    this.getUserDetails();
  }

  onHomeNavigate(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.EMPTY]);
  }

  onNavigateToRaffle(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.EMPTY, Paths.RAFFLES]);
  }

  onNavigateSignIn(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.AUTH, Paths.SIGN_IN]);
  }

  onNavigateInfluencerDashboard(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.INFLUENCER]);
  }

  onNavigateRaffles(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.INFLUENCER, Paths.ALL_RAFFLES]);
  }

  onNavigateTickets(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.MY_BOOKINGS]);
  }

  onNavigateUserProfile(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.PROFILE]);
  }

  onNavigatePolls(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.INFLUENCER, Paths.POLL]);
  }

  onNavigateSubscriptions(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.INFLUENCER, Paths.SUBSCRIPTION]);
  }

  onNavigatePosts(): void {
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.INFLUENCER, Paths.POSTS]);
  }

  onEnableDarkTheme(): void {
    this.appStateService.toggleSidebar();
    this.appStateService.toggleThememode();
  }

  onSignOut(): void {
    this.localStorageService.removeItem(LocalStorageKeys.USER_DETAILS);
    this.localStorageService.removeItem(LocalStorageKeys.ACCESS_TOKEN);
    this.jwtService.updateToken(null);
    this.toastr.success('User signed out successfully..!!');
    this.appStateService.toggleSidebar();
    this.router.navigate([Paths.EMPTY]);
  }

  private getUserDetails(): void {
    this.jwtService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.currentUserInfo = user;
        this.userRole = user?.role ?? null;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
